import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { IMAGES } from '../mock';

export default function AboutPreview() {
  return (
    <section className="section-pad relative overflow-hidden" style={{ background: 'var(--warm-white)' }}>
      <div className="absolute -top-16 -left-16 w-80 h-80 rounded-full opacity-30 animate-drift pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(232,165,169,0.28), transparent 70%)' }} />
      <div className="absolute -bottom-16 -right-16 w-[26rem] h-[26rem] rounded-full opacity-30 animate-breathe pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(184,190,164,0.35), transparent 70%)' }} />

      {/* Twinkles */}
      <div className="absolute top-16 right-24 twinkle w-2 h-2 rounded-full bg-[color:var(--dusty-rose)] opacity-70 pointer-events-none" />
      <div className="absolute top-40 right-60 twinkle w-1.5 h-1.5 rounded-full bg-[color:var(--sage-dark)] opacity-70 pointer-events-none" style={{ animationDelay: '1.2s' }} />
      <div className="absolute bottom-20 left-40 twinkle w-2 h-2 rounded-full bg-[color:var(--dusty-rose)] opacity-60 pointer-events-none" style={{ animationDelay: '2s' }} />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <div className="reveal-blur zoom-frame rounded-2xl overflow-hidden shadow-[0_30px_60px_-30px_rgba(78,87,69,0.2)] bg-white">
          <img
            src={IMAGES.belongHere}
            alt="Welcome — You Belong Here. Life can be overwhelming. You don't have to face it alone."
            className="w-full h-auto block"
          />
        </div>

        <div className="text-center mt-8 reveal">
          <Link to="/philosophy" className="btn-primary btn-glow">Discover Our Philosophy <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </section>
  );
}
